import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest } from "redux-saga/effects";
import { UserType, ADD_USER } from "./types";
import { addUserActionSuccess } from "./slice";

function* addUserSaga({ payload: userRequest }: PayloadAction<UserType>) {
  try {
    yield put(addUserActionSuccess(userRequest));
  } catch (error: any) {
    console.log("Error - ", error);
  }
}

export function* watchGetUser() {
  yield takeLatest(`${ADD_USER}/addUserAction`, addUserSaga);
}
